export default "/images/vendor/flag-icons/flags/1x1/cw.svg?023cc06898b0b15eeedc37a964aff02a";